import React from 'react'
import { HighlightProps } from 'react-instantsearch-core'
import { connectHighlight } from 'react-instantsearch-dom'

const HitText: React.FC<HighlightProps & { highlightProperty: string }> = ({
  highlight,
  attribute,
  hit,
  highlightProperty
}) => {
  const parsedHit = highlight({
    highlightProperty,
    attribute,
    hit
  })

  return (
    <>
      {parsedHit.map((part) =>
        part.isHighlighted ? <mark key={part.value}>{part.value}</mark> : <span key={part.value}>{part.value}</span>
      )}
    </>
  )
}

export const PageHitText = connectHighlight(HitText)
